var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/*
 * @Author: 姚阳子 yaoyangzi@linhuiba.com
 * @Date: 2023-05-12 15:33:27
 * @LastEditors: 姚阳子 yaoyangzi@linhuiba.com
 * @LastEditTime: 2023-06-07 20:18:12
 * @FilePath: /locationpms-pc/src/store/modules/crm.ts
 * @Description:
 *
 *
 */
import { crmMessagNumAPI } from '@/api/crm/message';
/**
 * 消息记录
 */
var app = {
    state: {
        // 待办事项消息
        messageNum: {},
        showRing: true,
        showTimer: false,
        showCallOut: false,
        isCall: false,
        callinTime: '00:00:00',
        qiniuToken: '',
        workbench: {}
    },
    mutations: {
        /**
         * 更改待办事项
         */
        SET_MESSAGENUM: function (state, messageNum) {
            var totalNum = 0;
            for (var key in messageNum) {
                if (key !== 'totalNum') {
                    totalNum += (messageNum[key] || 0);
                }
            }
            messageNum.totalNum = totalNum;
            state.messageNum = messageNum;
        },
        /**
         * 通话计时
         */
        CALL_STATUS: function (state, callinTime) {
            state.callinTime = callinTime;
        },
        /**
         * 振铃中
         */
        SHOW_RING: function (state, showRing) {
            state.showRing = showRing;
        },
        /**
         * 是否展示通话
         */
        SHOW_TIMER: function (state, showTimer) {
            state.showTimer = showTimer;
        },
        /**
         * 展示来电弹框
         */
        SHOW_CALL_OUT: function (state, showCallOut) {
            state.showCallOut = showCallOut;
        },
        /**
         * 呼叫中心权限
         */
        GET_IS_CALL: function (state, isCall) {
            state.isCall = isCall;
        },
        /**
         * 设置七牛token
         */
        SET_QINIU_TOKEN: function (state, token) {
            state.qiniuToken = token;
        },
        SET_WORKBENCH_FILTER: function (state, filter) {
            state.workbench = __assign({}, filter);
        },
    },
    actions: {
        // 登录
        // @ts-ignore
        GetMessageNum: function (_a) {
            var commit = _a.commit;
            return new Promise(function (resolve, reject) {
                crmMessagNumAPI({})
                    .then(function (response) {
                    commit('SET_MESSAGENUM', response.data);
                    // 待办事项 增加数量提示， 因合并入系统消息，暂时去掉
                    // commit('SET_CRMROUTERSNUM', state.messageNum.totalNum)
                    resolve(response);
                })
                    .catch(function (error) {
                    reject(error);
                });
            });
        }
    }
};
export default app;
